import { useEffect, useRef } from "react";
import useCallsStore, { ActiveMedia } from "../hooks/useCallsStore";
import { useShallow } from "zustand/shallow";
import { CallsLogger } from "../helpers";

type LocalStreamViewProps = { mirror?: boolean } & React.VideoHTMLAttributes<HTMLVideoElement>;

const LocalStreamView: React.FC<LocalStreamViewProps> = ({ muted, mirror, style = {}, ...props }) => {
  const [localStream, userMediaParams, displayMediaParams, activeMedia] = useCallsStore(
    useShallow((store) => [store.localStream, store.userMediaParams, store.displayMediaParams, store.activeMedia]),
  );
  const videoRef = useRef<HTMLVideoElement>(null);
  const isCamera = activeMedia === ActiveMedia.USER;
  const activeMediaParams = isCamera ? userMediaParams : displayMediaParams;
  const elementId = activeMediaParams.elementId ?? "ConnectyCubeMediaStream-local";
  const options = activeMediaParams.options ?? {};
  const isMuted = typeof muted === "boolean" ? muted : typeof options.muted === "boolean" ? options.muted : true;
  const isMirror =
    typeof mirror === "boolean" ? mirror : typeof options.mirror === "boolean" ? options.mirror : isCamera;
  const cssProps: React.CSSProperties = {
    transform: isMirror ? "scaleX(-1)" : "none",
    objectFit: "contain",
    height: "100%",
    width: "100%",
    ...style,
  };

  useEffect(() => {
    if (videoRef.current && localStream) {
      videoRef.current.srcObject = localStream;
      videoRef.current.onloadedmetadata = () => {
        try {
          videoRef.current?.play();
        } catch (error) {
          CallsLogger.error("<LocalStreamView/> play()", error);
        }
      };
    }
  }, [localStream]);

  return localStream ? (
    <video autoPlay playsInline ref={videoRef} id={elementId} muted={isMuted} style={cssProps} {...props} />
  ) : null;
};

export default LocalStreamView;
